/*
  Gentleren — Full Animations JS (v3)
  File: assets/gn-animations.js
  ─────────────────────────────────────────────────
  Add before </body> in theme.liquid:
  <script src="{{ 'gn-animations.js' | asset_url }}" defer></script>

  FEATURES:
  ✓ Page fade-in on load
  ✓ Page fade-out on navigation
  ✓ Elements fade IN when scrolled into view (slide up)
  ✓ Elements fade OUT when scrolled past (slide down/up)
  ✓ Staggered grid animations
  ✓ Back/forward browser support
*/

/* ══════════════════════════════════════════
   1. PAGE FADE-IN / FADE-OUT
   ══════════════════════════════════════════ */
(function () {
  var body = document.body;

  // Fallback: show page after 1s even if JS is slow
  var fallback = setTimeout(function () {
    body.classList.add('gn-page-ready');
  }, 1000);

  function fadeIn() {
    clearTimeout(fallback);
    body.classList.add('gn-page-ready');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fadeIn);
  } else {
    fadeIn();
  }

  // Fade out on internal link click
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href) return;

    var isExternal = link.hostname && link.hostname !== window.location.hostname;
    var isAnchor   = href.startsWith('#');
    var isSpecial  = href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:');
    var isNewTab   = link.target === '_blank';
    var isModified = e.ctrlKey || e.metaKey || e.shiftKey || e.altKey;

    if (isExternal || isAnchor || isSpecial || isNewTab || isModified) return;

    e.preventDefault();
    var destination = link.href;

    body.classList.remove('gn-page-ready');
    body.classList.add('gn-page-exit');

    setTimeout(function () {
      window.location.href = destination;
    }, 300);
  });

  // Handle bfcache (back/forward)
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      body.classList.remove('gn-page-exit');
      body.classList.add('gn-page-ready');
    }
  });
})();


/* ══════════════════════════════════════════
   2. SCROLL REVEAL — fade in & fade out
   ══════════════════════════════════════════ */
(function () {
  'use strict';

  // Elements to animate
  var AUTO_SELECTORS = [
    /* Hero */
    '.banner__content',
    '.hero__content',
    '.slideshow__text-wrapper',
    /* Headings */
    '.collection-list__title',
    '.featured-collection__title',
    '.section-header',
    '.gn-faq-header',
    '.gn-section-title',
    'h2.title',
    /* Cards */
    '.card-wrapper',
    '.gn-rel-card',
    '.collection-list__item',
    /* Testimonials */
    '.testimonials-slider__slide',
    '.gn-testimonial',
    /* FAQ */
    '.gn-faq-item',
    /* Rich text */
    '.rich-text__wrapper',
    '.rich-text__blocks > *',
    /* Banners */
    '.image-banner',
    '.media-with-text__media',
    '.media-with-text__text-item',
    /* Footer */
    '.footer__content-top',
    '.footer__column',
    /* Gentleren custom */
    '.gn-product-grid > *',
    '.gn-related-grid > *',
    '.gn-features',
    '.gn-accordion',
    '.gn-price-row',
    '.gn-title',
    '.gn-vendor',
  ];

  var STAGGER_PARENTS = [
    '.product-grid',
    '.collection-list',
    '.gn-related-grid',
    '.gn-faq-list',
    '.testimonials-slider',
  ];

  var DELAYS = [0, 100, 200, 300, 400, 500];

  function isAboveFold(el) {
    return el.getBoundingClientRect().top < window.innerHeight * 0.1;
  }

  function tag(el, variant, delay) {
    if (el.hasAttribute('data-gn-reveal')) return;
    el.setAttribute('data-gn-reveal', variant || 'slide');
    if (delay) el.setAttribute('data-gn-delay', String(delay));
    // Elements already visible on load → show immediately, no animation
    if (isAboveFold(el)) {
      el.classList.add('gn-visible');
    }
  }

  function autoTag() {
    AUTO_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        tag(el, 'slide');
      });
    });

    document.querySelectorAll('.card__media, .gn-image-main, .gn-rel-img').forEach(function (el) {
      tag(el, 'scale');
    });

    STAGGER_PARENTS.forEach(function (parentSel) {
      document.querySelectorAll(parentSel).forEach(function (parent) {
        Array.from(parent.children).forEach(function (child, i) {
          tag(child, 'slide', DELAYS[Math.min(i, DELAYS.length - 1)]);
        });
      });
    });
  }

  // ── IntersectionObserver with fade IN and OUT ──
  function initObserver() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-gn-reveal]').forEach(function (el) {
        el.classList.add('gn-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var el = entry.target;

        if (entry.isIntersecting) {
          // Coming into view → fade IN
          el.classList.remove('gn-hidden-below', 'gn-hidden-above');
          el.classList.add('gn-visible');
        } else {
          // Leaving view → fade OUT
          if (!el.classList.contains('gn-visible')) return; // never shown yet, skip

          var rect = el.getBoundingClientRect();
          if (rect.top > 0) {
            // Element is below viewport (scrolled up past it)
            el.classList.remove('gn-visible', 'gn-hidden-above');
            el.classList.add('gn-hidden-below');
          } else {
            // Element is above viewport (scrolled down past it)
            el.classList.remove('gn-visible', 'gn-hidden-below');
            el.classList.add('gn-hidden-above');
          }
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -30px 0px'
    });

    document.querySelectorAll('[data-gn-reveal]').forEach(function (el) {
      if (!el.classList.contains('gn-visible')) {
        observer.observe(el);
      } else {
        // Already visible (above fold) — still observe for fade-out on scroll up
        observer.observe(el);
      }
    });
  }

  function init() {
    autoTag();
    initObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when Theme Editor loads a new section
  document.addEventListener('shopify:section:load', function () {
    autoTag();
    initObserver();
  });

})();